(function () {
  const PROJECTIONS = [120, 170, 220, 270, 320, 370];
  /** Match reference order: Left, Right, Back, Front */
  const SIDE_ORDER = ["left", "right", "back", "front"];
  const COLOURS = [
    { name: "White", tiger: "029/10797", swatch: "#f2f2f2", imgKey: "white" },
    { name: "Anthracite Grey", tiger: "029/71289", swatch: "#3a4045", imgKey: "anthracite" },
    { name: "Black", tiger: "029/80303", swatch: "#111111", imgKey: "black" },
  ];
  const DRIVES = [
    {
      id: "Manual",
      title: "Manual Retractable Screen",
      blurb: "Pull down / push up · no wiring",
    },
    {
      id: "Solar",
      title: "Solar Retractable Screen",
      blurb: "Remote controlled · no wiring",
    },
  ];

  function selectionLabel(drive, colour) {
    return drive + " Screen · " + colour;
  }

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.from(root.querySelectorAll(sel));
  }

  function readJson(sel) {
    const el = document.querySelector(sel);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || "{}");
    } catch (e) {
      return null;
    }
  }

  function parseSizeLabel(label) {
    if (!label) return null;
    const match = String(label)
      .replace(/×/g, "x")
      .match(/(\d+(?:\.\d+)?)\s*m?\s*x\s*(\d+(?:\.\d+)?)\s*m?/i);
    if (!match) return null;
    // Size "Am x Bm": A = Left/Right (sides), B = Front/Back
    return {
      leftRightCm: Math.round(parseFloat(match[1]) * 100),
      frontBackCm: Math.round(parseFloat(match[2]) * 100),
    };
  }

  function projectionForHeightMm(mm) {
    const cm = Math.ceil(Number(mm) / 10);
    for (const p of PROJECTIONS) {
      if (p >= cm) return p;
    }
    return PROJECTIONS[PROJECTIONS.length - 1];
  }

  function openingsForWidth(cm) {
    if (cm >= 600) {
      return [
        { widthCm: 300, bay: "1", labelSuffix: " · bay 1" },
        { widthCm: 300, bay: "2", labelSuffix: " · bay 2" },
      ];
    }
    return [{ widthCm: cm, bay: "1", labelSuffix: "" }];
  }

  function sideTitle(side) {
    return side.charAt(0).toUpperCase() + side.slice(1);
  }

  function metresLabel(cm) {
    const m = cm / 100;
    return Number.isInteger(m) ? m + "m" : m.toFixed(1).replace(/\.0$/, "") + "m";
  }

  function formatMoney(cents, moneyFormat) {
    const format = moneyFormat || "£{{amount}}";
    if (window.FoxTheme && FoxTheme.Currency && typeof FoxTheme.Currency.formatMoney === "function") {
      return FoxTheme.Currency.formatMoney(cents, format);
    }
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, format);
    }
    const amount = (Number(cents) / 100).toFixed(2);
    const withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return format.replace(/\{\{\s*amount\s*\}\}/g, withCommas);
  }

  /** Simple isometric pergola glyph with one side highlighted */
  function sideThumbSvg(side) {
    const fill = "#2a2f33";
    const mesh = "rgba(120,130,140,0.5)";
    const posts = [
      [36, 58],
      [100, 34],
      [164, 58],
      [100, 82],
    ];
    const edges = {
      left: [
        [36, 58],
        [100, 82],
      ],
      right: [
        [100, 34],
        [164, 58],
      ],
      back: [
        [36, 58],
        [100, 34],
      ],
      front: [
        [100, 82],
        [164, 58],
      ],
    };
    const e = edges[side] || edges.front;
    return (
      '<svg class="sunnier-screens__thumb-svg" viewBox="0 0 200 120" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<polygon points="36,58 100,34 164,58 100,82" fill="#ececea" stroke="' +
      fill +
      '" stroke-width="2.5"/>' +
      '<line x1="' +
      e[0][0] +
      '" y1="' +
      e[0][1] +
      '" x2="' +
      e[1][0] +
      '" y2="' +
      e[1][1] +
      '" stroke="' +
      mesh +
      '" stroke-width="12" stroke-linecap="round"/>' +
      '<line x1="' +
      e[0][0] +
      '" y1="' +
      e[0][1] +
      '" x2="' +
      e[1][0] +
      '" y2="' +
      e[1][1] +
      '" stroke="' +
      fill +
      '" stroke-width="2.5"/>' +
      posts
        .map(function (p) {
          return (
            '<rect x="' +
            (p[0] - 2.5) +
            '" y="' +
            p[1] +
            '" width="5" height="22" rx="1" fill="' +
            fill +
            '"/>'
          );
        })
        .join("") +
      "</svg>"
    );
  }

  function init(root) {
    if (!root || root.dataset.sunnierScreensInit === "true") return;
    root.dataset.sunnierScreensInit = "true";

    const variantMap = readJson("[data-sunnier-screen-map]");
    const matrix = readJson("[data-sunnier-screen-matrix]");
    if (!variantMap || !matrix) return;

    const cardsEl = qs(root, "[data-sunnier-screen-cards]");
    const dialog = document.querySelector("[data-sunnier-screens-dialog]");
    const gridEl = dialog && qs(dialog, "[data-sunnier-dialog-grid]");
    const noteEl = qs(root, "[data-sunnier-screens-note]");
    const totalEl = qs(root, "[data-sunnier-screens-total]");
    const moneyFormat =
      (document.querySelector("[data-sunnier-pergola-options]") || {}).dataset?.moneyFormat ||
      "£{{amount}}";
    const colourImages = {
      white: root.dataset.screenImgWhite || "",
      anthracite: root.dataset.screenImgAnthracite || "",
      black: root.dataset.screenImgBlack || "",
    };

    function colourImageUrl(colourName) {
      const meta = COLOURS.find((c) => c.name === colourName);
      if (!meta) return colourImages.anthracite || "";
      return colourImages[meta.imgKey] || "";
    }

    /** @type {Record<string, any>} */
    const selections = {};
    /** @type {Record<string, string>} pending colour per drive in open dialog */
    const draftColours = { Manual: "White", Solar: "White" };
    let activeBayKey = null;
    let lockedDrive = null;

    function getSelectedOptions() {
      const cfg = window.SunnierPergolaConfig;
      if (cfg) {
        return {
          size: cfg.getSizeLabel ? cfg.getSizeLabel() : "",
          mount: cfg.getMountLabel ? cfg.getMountLabel() : "",
        };
      }
      let size = "";
      let mount = "";
      qsa(document, "variant-selects .product-form__input, .product-form__input").forEach((group) => {
        const label = group.querySelector(".form__label");
        const text = (label && label.textContent) || "";
        const checked = group.querySelector('input[type="radio"]:checked');
        if (!checked) return;
        const clean = String(checked.value || "").trim();
        if (/size/i.test(text) || /\d+\s*m\s*x/i.test(clean)) size = clean;
        if (/mount/i.test(text)) mount = clean;
      });
      return { size, mount };
    }

    function currentHeightMm() {
      const cfg = window.SunnierPergolaConfig;
      if (cfg && typeof cfg.getHeightMm === "function") return cfg.getHeightMm();
      const options = document.querySelector("[data-sunnier-pergola-options]");
      if (!options) return 2350;
      const custom = options.querySelector('input[name="sunnier-height-mode"][value="custom"]');
      const input = options.querySelector("[data-sunnier-height-input]");
      if (custom && custom.checked && input) return Number(input.value) || 2350;
      return Number(options.dataset.standardHeight || 2350);
    }

    function isWallMounted() {
      return /wall/i.test(getSelectedOptions().mount || "");
    }

    function sideWidthCm(side) {
      const dims = parseSizeLabel(getSelectedOptions().size);
      if (!dims) return 300;
      if (side === "front" || side === "back") return dims.frontBackCm;
      return dims.leftRightCm;
    }

    function bayKey(side, bay) {
      return side + ":" + bay;
    }

    function lookupVariant(drive, colour, widthCm, projectionCm) {
      return variantMap[drive + "|" + colour + "|" + widthCm + "x" + projectionCm] || null;
    }

    function priceCentsFor(drive, colour, widthCm, projectionCm) {
      const hit = lookupVariant(drive, colour, widthCm, projectionCm);
      if (hit) return hit.priceCents;
      const table = drive === "Solar" ? matrix.solarGbp : matrix.manualGbp;
      const pounds = table && table[String(projectionCm)] && table[String(projectionCm)][String(widthCm)];
      return pounds != null ? Math.round(Number(pounds) * 100) : 0;
    }

    function buildBays() {
      const wall = isWallMounted();
      const projectionCm = projectionForHeightMm(currentHeightMm());
      const bays = [];
      SIDE_ORDER.forEach((side) => {
        openingsForWidth(sideWidthCm(side)).forEach((opening) => {
          const disabled = wall && side === "back";
          bays.push({
            key: bayKey(side, opening.bay),
            side,
            bay: opening.bay,
            widthCm: opening.widthCm,
            edgeWidthCm: sideWidthCm(side),
            projectionCm,
            label: sideTitle(side) + opening.labelSuffix,
            disabled,
            reason: disabled ? "Not available on wall-mounted (against wall)" : "",
          });
        });
      });
      return bays;
    }

    function syncSelectionsToBays(bays) {
      Object.keys(selections).forEach((key) => {
        const bay = bays.find((b) => b.key === key);
        if (!bay || bay.disabled) {
          delete selections[key];
          return;
        }
        const sel = selections[key];
        if (sel.widthCm !== bay.widthCm || sel.projectionCm !== bay.projectionCm) {
          const next = lookupVariant(sel.drive, sel.colour, bay.widthCm, bay.projectionCm);
          if (!next) {
            delete selections[key];
            return;
          }
          sel.widthCm = bay.widthCm;
          sel.projectionCm = bay.projectionCm;
          sel.variantId = next.numericId;
          sel.priceCents = next.priceCents;
        }
      });
      lockedDrive = null;
      Object.values(selections).forEach((sel) => {
        if (!lockedDrive) lockedDrive = sel.drive;
      });
    }

    function renderCards() {
      if (!cardsEl) return;
      const bays = buildBays();
      syncSelectionsToBays(bays);
      cardsEl.innerHTML = "";

      bays.forEach((bay) => {
        const selected = selections[bay.key];
        const sideName = sideTitle(bay.side);
        const sideCaption =
          openingsForWidth(bay.edgeWidthCm).length > 1
            ? sideName + " · Bay " + bay.bay
            : sideName;

        if (selected) {
          const card = document.createElement("div");
          card.className = "sunnier-screens__card is-filled";
          card.setAttribute(
            "aria-label",
            sideCaption + ", " + selectionLabel(selected.drive, selected.colour)
          );
          card.innerHTML =
            '<span class="sunnier-screens__card-media">' +
            '<img class="sunnier-screens__card-photo" src="' +
            colourImageUrl(selected.colour) +
            '" alt="" loading="lazy" width="400" height="300">' +
            '<span class="sunnier-screens__card-actions sunnier-screens__card-actions--hover">' +
            '<button type="button" class="sunnier-screens__card-action sunnier-screens__card-action--replace" data-action="replace">' +
            "Replace</button>" +
            '<button type="button" class="sunnier-screens__card-action sunnier-screens__card-action--remove" data-action="remove">' +
            "Remove</button>" +
            "</span>" +
            "</span>" +
            '<span class="sunnier-screens__card-body">' +
            '<span class="sunnier-screens__card-side">' +
            sideCaption +
            "</span>" +
            '<span class="sunnier-screens__card-selected">' +
            selectionLabel(selected.drive, selected.colour) +
            "</span>" +
            '<span class="sunnier-screens__card-price">' +
            formatMoney(selected.priceCents, moneyFormat) +
            "</span>" +
            "</span>" +
            '<span class="sunnier-screens__card-actions sunnier-screens__card-actions--mobile">' +
            '<button type="button" class="sunnier-screens__card-action sunnier-screens__card-action--replace" data-action="replace">' +
            "Replace</button>" +
            '<button type="button" class="sunnier-screens__card-action sunnier-screens__card-action--remove" data-action="remove">' +
            "Remove</button>" +
            "</span>";

          qsa(card, '[data-action="replace"]').forEach((btn) => {
            btn.addEventListener("click", (event) => {
              event.stopPropagation();
              openDialog(bay.key);
            });
          });
          qsa(card, '[data-action="remove"]').forEach((btn) => {
            btn.addEventListener("click", (event) => {
              event.stopPropagation();
              delete selections[bay.key];
              renderCards();
            });
          });
          cardsEl.appendChild(card);
          return;
        }

        const card = document.createElement("button");
        card.type = "button";
        card.className = "sunnier-screens__card" + (bay.disabled ? " is-disabled" : "");
        card.disabled = !!bay.disabled;
        card.setAttribute("aria-label", sideCaption + ", " + metresLabel(bay.widthCm) + ", add enclosure");
        card.innerHTML =
          '<span class="sunnier-screens__card-media">' +
          sideThumbSvg(bay.side) +
          "</span>" +
          '<span class="sunnier-screens__card-body">' +
          '<span class="sunnier-screens__card-plus" aria-hidden="true">+</span>' +
          '<span class="sunnier-screens__card-side">' +
          sideCaption +
          "</span>" +
          '<span class="sunnier-screens__card-dim">' +
          metresLabel(bay.widthCm) +
          "</span>" +
          "</span>";

        if (bay.disabled) card.title = bay.reason;
        else card.addEventListener("click", () => openDialog(bay.key));
        cardsEl.appendChild(card);
      });

      if (noteEl) {
        if (isWallMounted()) {
          noteEl.hidden = false;
          noteEl.textContent = "Back side is unavailable for wall-mounted pergolas.";
        } else {
          noteEl.hidden = true;
        }
      }

      updateTotals();
      notifyChange();
    }

    function updateTotals() {
      const items = Object.values(selections);
      if (!totalEl) return;
      if (!items.length) {
        totalEl.hidden = true;
        totalEl.textContent = "";
        return;
      }
      const cents = items.reduce((sum, s) => sum + s.priceCents, 0);
      totalEl.hidden = false;
      totalEl.textContent =
        items.length +
        (items.length === 1 ? " screen" : " screens") +
        " · " +
        formatMoney(cents, moneyFormat);
    }

    function closeDialog() {
      activeBayKey = null;
      if (!dialog) return;
      if (typeof dialog.close === "function") dialog.close();
      else dialog.removeAttribute("open");
    }

    function openDialog(key) {
      if (!dialog || !gridEl) return;
      activeBayKey = key;
      const bay = buildBays().find((b) => b.key === key);
      if (!bay || bay.disabled) return;

      const existing = selections[key];
      if (existing) {
        draftColours[existing.drive] = existing.colour;
      }

      qs(dialog, "[data-sunnier-dialog-title]").textContent =
        (existing ? "Edit " : "Add ") + metresLabel(bay.widthCm) + " side";
      qs(dialog, "[data-sunnier-dialog-sub]").textContent =
        bay.label +
        " · screen " +
        bay.widthCm +
        " × " +
        bay.projectionCm +
        " cm (from your size & height)";

      const otherKeys = Object.keys(selections).filter((k) => k !== key);
      const lockTo = otherKeys.length
        ? lockedDrive || selections[otherKeys[0]]?.drive
        : null;
      const lockNote = qs(dialog, "[data-sunnier-drive-lock-note]");
      if (lockNote) lockNote.hidden = !lockTo;

      const footer = qs(dialog, "[data-sunnier-dialog-footer]");
      if (footer) footer.hidden = !existing;

      renderDialogProducts(bay, lockTo, existing);

      if (typeof dialog.showModal === "function") dialog.showModal();
      else dialog.setAttribute("open", "");
    }

    function renderDialogProducts(bay, lockTo, existing) {
      gridEl.innerHTML = "";
      DRIVES.forEach((drive) => {
        const lockedOut = !!(lockTo && lockTo !== drive.id);
        const colour = draftColours[drive.id] || "White";
        const cents = priceCentsFor(drive.id, colour, bay.widthCm, bay.projectionCm);
        const isCurrent =
          existing && existing.drive === drive.id && existing.colour === colour;

        const card = document.createElement("article");
        card.className =
          "sunnier-screen-product" +
          (lockedOut ? " is-locked" : "") +
          (existing && existing.drive === drive.id ? " is-selected" : "");

        const colourHtml = COLOURS.map((c) => {
          const active = c.name === colour;
          return (
            '<button type="button" class="sunnier-screen-product__swatch' +
            (active ? " is-active" : "") +
            '" data-drive="' +
            drive.id +
            '" data-colour="' +
            c.name +
            '" style="--swatch:' +
            c.swatch +
            '" title="' +
            c.name +
            '" aria-label="' +
            c.name +
            '"' +
            (lockedOut ? " disabled" : "") +
            "></button>"
          );
        }).join("");

        const colourMeta = COLOURS.find((c) => c.name === colour);

        const photoUrl = colourImageUrl(colour);
        card.innerHTML =
          '<div class="sunnier-screen-product__media">' +
          (photoUrl
            ? '<img class="sunnier-screen-product__photo" src="' +
              photoUrl +
              '" alt="' +
              colour +
              ' screen" loading="lazy" width="640" height="480">'
            : "") +
          "</div>" +
          '<h5 class="sunnier-screen-product__title">' +
          drive.title +
          "</h5>" +
          '<p class="sunnier-screen-product__blurb">' +
          drive.blurb +
          "</p>" +
          '<div class="sunnier-screen-product__colours" role="group" aria-label="Colour">' +
          colourHtml +
          "</div>" +
          '<p class="sunnier-screen-product__colour-name">' +
          colour +
          '<small>Tiger ' +
          (colourMeta ? colourMeta.tiger : "") +
          "</small></p>" +
          '<p class="sunnier-screen-product__price" data-price-for="' +
          drive.id +
          '">' +
          formatMoney(cents, moneyFormat) +
          "</p>" +
          '<button type="button" class="sunnier-screen-product__add" data-add-drive="' +
          drive.id +
          '"' +
          (lockedOut ? " disabled" : "") +
          ">" +
          (isCurrent || (existing && existing.drive === drive.id)
            ? "Update selection"
            : "Add screen") +
          "</button>";

        gridEl.appendChild(card);
      });

      qsa(gridEl, "[data-colour]").forEach((btn) => {
        btn.addEventListener("click", () => {
          const drive = btn.dataset.drive;
          draftColours[drive] = btn.dataset.colour;
          renderDialogProducts(bay, lockTo, existing);
        });
      });

      qsa(gridEl, "[data-add-drive]").forEach((btn) => {
        btn.addEventListener("click", () => {
          addScreen(bay, btn.dataset.addDrive);
        });
      });
    }

    function addScreen(bay, drive) {
      const colour = draftColours[drive] || "White";
      const others = Object.values(selections).filter(
        (s) => bayKey(s.side, s.bay) !== bay.key
      );
      if (others.length && others[0].drive !== drive) {
        alert("All screens on this order must use the same drive (" + others[0].drive + ").");
        return;
      }
      const variant = lookupVariant(drive, colour, bay.widthCm, bay.projectionCm);
      if (!variant) {
        alert("That screen size is not available. Try another height or contact us.");
        return;
      }
      selections[bay.key] = {
        side: bay.side,
        bay: bay.bay,
        drive,
        colour,
        widthCm: bay.widthCm,
        projectionCm: bay.projectionCm,
        variantId: variant.numericId,
        priceCents: variant.priceCents,
      };
      closeDialog();
      renderCards();
    }

    if (dialog) {
      const closeBtn = qs(dialog, "[data-sunnier-dialog-close]");
      if (closeBtn) closeBtn.addEventListener("click", closeDialog);
      dialog.addEventListener("click", (event) => {
        if (event.target === dialog) closeDialog();
      });
      const removeBtn = qs(dialog, "[data-sunnier-dialog-remove]");
      if (removeBtn) {
        removeBtn.addEventListener("click", () => {
          if (activeBayKey) delete selections[activeBayKey];
          closeDialog();
          renderCards();
        });
      }
    }

    function notifyChange() {
      document.dispatchEvent(new CustomEvent("sunnier:screens-changed", { bubbles: true }));
    }

    function colourShort(name) {
      const n = String(name || "").toLowerCase();
      if (n.indexOf("black") >= 0) return "Black";
      if (n.indexOf("anthracite") >= 0) return "Anthracite";
      return "White";
    }

    function colourFull(name) {
      const n = String(name || "").toLowerCase();
      if (n.indexOf("black") >= 0) return "Black";
      if (n.indexOf("anthracite") >= 0) return "Anthracite Grey";
      return "White";
    }

    function sideLetter(side) {
      const s = String(side || "").toLowerCase();
      if (s === "right") return "R";
      if (s === "back") return "B";
      if (s === "front") return "F";
      return "L";
    }

    function sideFromLetter(letter) {
      const s = String(letter || "").toUpperCase();
      if (s === "R") return "right";
      if (s === "B") return "back";
      if (s === "F") return "front";
      return "left";
    }

    function serializeSelections() {
      return Object.values(selections)
        .map((sel) => {
          return (
            sideLetter(sel.side) +
            String(sel.bay || "1") +
            "-" +
            sel.drive +
            "-" +
            colourShort(sel.colour)
          );
        })
        .join(",");
    }

    function applySerialized(raw) {
      if (!raw) return false;
      const bays = buildBays();
      const next = {};
      String(raw)
        .split(",")
        .map((part) => part.trim())
        .filter(Boolean)
        .forEach((token) => {
          const match = token.match(/^([LRBF])(\d+)-(Manual|Solar)-(.+)$/i);
          if (!match) return;
          const side = sideFromLetter(match[1]);
          const bay = match[2];
          const drive = match[3][0].toUpperCase() + match[3].slice(1).toLowerCase();
          const colour = colourFull(match[4]);
          const key = bayKey(side, bay);
          const opening = bays.find((b) => b.key === key);
          if (!opening || opening.disabled) return;
          const variant = lookupVariant(drive, colour, opening.widthCm, opening.projectionCm);
          if (!variant) return;
          next[key] = {
            side,
            bay,
            drive,
            colour,
            widthCm: opening.widthCm,
            projectionCm: opening.projectionCm,
            variantId: variant.numericId,
            priceCents: variant.priceCents,
          };
        });
      Object.keys(selections).forEach((key) => delete selections[key]);
      Object.keys(next).forEach((key) => {
        selections[key] = next[key];
      });
      lockedDrive = null;
      Object.values(selections).forEach((sel) => {
        if (!lockedDrive) lockedDrive = sel.drive;
      });
      renderCards();
      return Object.keys(selections).length > 0;
    }

    window.SunnierPergolaScreens = {
      getExtraCents() {
        return Object.values(selections).reduce((sum, s) => sum + s.priceCents, 0);
      },
      serialize: serializeSelections,
      applySerialized,
      getInstallItems() {
        return Object.values(selections).map((sel) => ({
          drive: sel.drive,
          widthCm: sel.widthCm,
        }));
      },
      getSummaryParts() {
        const items = Object.values(selections);
        if (!items.length) return [];
        return [
          items.length +
            (items.length === 1 ? " screen" : " screens") +
            " (" +
            items[0].drive +
            ")",
        ];
      },
      getCartItems(bundleId) {
        return Object.values(selections).map((sel) => {
          const multiBay = openingsForWidth(sideWidthCm(sel.side)).length > 1;
          return {
            id: Number(sel.variantId),
            quantity: 1,
            properties: {
              "Addon type": "Side screen",
              Side: sideTitle(sel.side) + (multiBay ? " bay " + sel.bay : ""),
              Drive: sel.drive,
              Colour: sel.colour,
              Size: sel.widthCm + " × " + sel.projectionCm + " cm",
              For: "Pergola Classic",
              _sunnier_bundle: bundleId,
              _sunnier_bundle_addon: "1",
            },
          };
        });
      },
      refresh: renderCards,
    };

    document.addEventListener("variant:changed", () => renderCards());
    document.addEventListener("sunnier:config-ready", () => renderCards());
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
      try {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, () =>
          renderCards()
        );
      } catch (e) {
        /* ignore */
      }
    }
    document.addEventListener("change", (event) => {
      const t = event.target;
      if (!t) return;
      if (
        t.name === "sunnier-height-mode" ||
        t.matches?.("[data-sunnier-height-input]") ||
        t.name === "sunnier-assembly"
      ) {
        renderCards();
      }
    });
    document.addEventListener("input", (event) => {
      if (event.target && event.target.matches?.("[data-sunnier-height-input]")) renderCards();
    });

    const sc = new URLSearchParams(location.search).get("sc");
    if (sc) applySerialized(sc);
    else renderCards();
    setTimeout(renderCards, 300);
  }

  function boot() {
    qsa(document, "[data-sunnier-screens]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
